<mat-toolbar class="fullscreen-toolbar" color="primary">
  <mat-toolbar-row>
    <div class="toolbar-content">
      @if (!gridStore.changes) {
        <h3>{{ "scheduler.visit-type.chooser.title" | translate }}</h3>
      }
      <span class="flex-spacer"></span>
      <a mat-icon-button matDialogClose="" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-form-field class="search-field" subscriptSizing="dynamic">
  <mat-label>{{ "scheduler.visit-type.chooser.search" | translate }}</mat-label>
  <input
    [formControl]="searchControl"
    autocomplete="off"
    matInput
    placeholder="{{
      'scheduler.visit-type.chooser.search.placeholder' | translate
    }}"
  />
  @if (searchControl.value) {
    <button
      (click)="searchControl.setValue('')"
      aria-label="Clear search"
      mat-icon-button
      matSuffix
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>

<div class="grid-container">
  <app-grid
    [cellClick]="onCellClick"
    [columns]="columns"
    [filter]="false"
    [hideHeaders]="true"
    [readOnly]="false"
    [showContextMenu]="true"
    [showDirty]="false"
    [showRemoveRowInContextMenu]="false"
    [store]="gridStore"
    [width]="'100%'"
  ></app-grid>
</div>

<mat-paginator
  (page)="pageEvent = $event; selectPage()"
  [length]="gridStore.remoteTotal"
  [pageIndex]="gridStore.currentPage - 1"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="gridStore.pageSize"
  hidePageSize="false"
  showFirstLastButtons="true"
>
</mat-paginator>
